import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const AgentListReportProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `ReportCustomEmail/AgentList/`, method: 'POST', payload: props, secure: true });
    }, [execute]);


    const value = { data, clearData, createRecord };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useAgentListReportStore = () => React.useContext(Context);
